import './App.css';
import React from 'react';
import Resume from './components/resume/Resume';

function App() {
  return (
    <div className="base">
       <Resume />
    </div>
  );
}

export default App;